/** Cache keys, never arbitrary image URLs, cross the public/Chat rendering boundary. */
export const THUMBNAIL_ORIGIN = 'https://brief.interaction.hnine.com';
/** Google News intermediary pages advertise a service logo, not the source article image. */
export function isArticleImagePage(url: string): boolean {
  try { return new URL(url).hostname.toLowerCase() !== 'news.google.com'; } catch { return false; }
}
export function thumbnailPath(key?: string | null): string | null {
  return typeof key === 'string' && /^[a-f0-9]{64}$/.test(key) ? `/api/article-images/${key}.jpg` : null;
}
export function chatThumbnailUrl(key?: string | null): string | null {
  const path = thumbnailPath(key);
  return path ? THUMBNAIL_ORIGIN + path : null;
}
